// i18n area 'hci' — locale hu-HU (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/hci.hu-HU.meta.json.
import type { enUS } from './hci'

export const huHU: typeof enUS = {
  hci: {
    ceph: {
      title: 'Ceph-klaszterek',
      createButton: 'Ceph-klaszter létrehozása',
      emptyTitle: 'Nincs kezelt Ceph-klaszter',
      emptyBody: 'A TVirt a tagcsomópontokon telepíti és birtokolja a Ceph-et, hiperkonvergensen a VM-terheléssel. Hozz létre egy klasztert: az első monitor és a hozzá tartozó manager automatikusan a kiválasztott vezérlő csomóponton születik — utána növeld további monitorokkal és OSD-eszközökkel.',
      pageTitle: 'Ceph-klaszter',
      colState: 'Állapot',
      colMembers: 'Tagok',
      colSize: 'Méret',
      colVersion: 'Ceph-verzió',
      sizeCell: '{used} GiB használatban / {total} GiB összesen',
      phase: {
        'not-deployed': 'Nincs üzembe helyezve',
        deploying: 'Üzembe helyezés folyamatban',
        healthy: 'Egészséges',
        degraded: 'Degradált',
        error: 'Hiba',
        destroying: 'Megsemmisítés alatt',
        destroyed: 'Megsemmisítve'
      },
      health: {
        HEALTH_OK: 'Egészséges (HEALTH_OK)',
        HEALTH_WARN: 'Figyelmeztetésekkel (HEALTH_WARN)',
        HEALTH_ERR: 'Hibaállapotban (HEALTH_ERR)',
        unknown: 'Még nem megfigyelt',
        observedAt: 'megfigyelve {time}'
      },
      create: {
        title: 'Ceph-klaszter létrehozása',
        info: 'Új Ceph-klaszter létrehozásakor ki kell választani az első csomópontot, amelyre a MON és MGR szerepkörök települnek. Meg kell adni azt is, melyik alhálózaton fusson a Ceph-forgalom: a public subnet az általános hálózati forgalomé, a cluster subnet pedig az OSD-k közötti belső replikációé; nem feltétlenül kell két külön alhálózat.',
        controlNode: 'Vezérlő csomópont',
        controlNodeHint: 'A tagcsomópont, ahol az első MON + MGR születik.',
        publicSubnet: 'Public alhálózat',
        publicSubnetHint: 'Egy, az IPAM-ban regisztrált alhálózat — a Ceph public_networkje. A létrehozás után nem módosítható.',
        clusterSubnet: 'Cluster alhálózat',
        clusterSubnetHint: 'Egy, az IPAM-ban regisztrált alhálózat — a Ceph cluster_networkje (replikáció/backfill).',
        noSubnets: 'Nincs regisztrált alhálózat — hozd létre őket előbb az IPAM-ban',
        sameSubnet: 'Ugyanaz az alhálózat a public és a cluster forgalomnak',
        sameSubnetHint: 'Bepipálva = a cluster hálózat (replikáció/backfill) egybeesik a public-kal. Pipa nélkül = válaszd ki a saját alhálózatát ÉS a vezérlő csomópont címét azon belül.',
        controlAddress: 'A vezérlő csomópont címe',
        controlAddressHint: 'Egy cím, amelyet az IPAM ismer a csomóponthoz a public alhálózaton belül.',
        controlClusterAddress: 'A vezérlő csomópont cluster-címe',
        controlClusterAddressHint: 'Egy cím, amelyet az IPAM ismer a csomóponthoz a cluster alhálózaton belül.',
        noAddresses: 'Az IPAM nem ismer címet ehhez a csomóponthoz a kiválasztott alhálózaton belül',
        started: 'Klaszter létrehozva — a bootstrap makrofeladatként folytatódik; a fázis magától frissül',
        error: 'A klaszter el lett utasítva'
      },
      detail: {
        actions: 'Elérhető műveletek',
        tabOverview: 'Áttekintés',
        tabManagementNodes: 'MON & MGR',
        tabDisks: 'OSD',
        tabPools: 'Készletek',
        tabObjects: 'Objektumok',
        tabCrush: 'CRUSH Map',
        tabCephfs: 'CephFS',
        tabAdvanced: 'Haladó',
        phase: 'Fázis',
        checksTitle: 'Aktív health checkek',
        noChecks: 'Nincs aktív health check',
        checkMuted: 'némítva',
        summaryPools: 'Készletek',
        summaryFilesystems: 'Fájlrendszerek',
        nodesCard: 'Csomópontok',
        monHint: 'Minden MON mellett egy vele kolokált MGR fut. Három MON az ajánlott kvórum; egy laborklaszter eggyel indul. Az OSD-k és az MDS-ek a saját lapjaikon élnek.',
        monHintSplit: 'A MON és az MGR ezen a klaszteren szétválasztott (Haladó): mindkét szerepkör önálló, csomópontonkénti tagság. Három MON az ajánlott kvórum; legalább egy MGR-nek léteznie kell.',
        noMons: 'Nincs deklarált monitor',
        addNode: 'Csomópont hozzáadása',
        removeNode: 'Csomópont eltávolítása',
        removeNodeFrom: 'A(z) {node} csomópont eltávolítása (a MON-ja és a kolokált MGR)',
        roleMon: 'MON szerepkör',
        roleMgr: 'MGR szerepkör',
        roleNa: 'N/A',
        roleNotObserved: 'még nem megfigyelt',
        monInQuorum: 'kvórumban',
        monOutQuorum: 'kvórumon kívül',
        mgrActive: 'aktív',
        mgrStandby: 'standby',
        addRoleMon: 'MON szerepkör hozzáadása',
        removeRoleMon: 'MON szerepkör eltávolítása',
        addRoleMgr: 'MGR szerepkör hozzáadása',
        removeRoleMgr: 'MGR szerepkör eltávolítása',
        restartMon: 'MON-szolgáltatás újraindítása',
        restartMgr: 'MGR-szolgáltatás újraindítása',
        addMon: 'MON hozzáadása',
        removeMon: 'MON eltávolítása',
        removeMonFrom: 'A MON szerepkör eltávolítása innen: {node}',
        addMgr: 'MGR hozzáadása',
        removeMgr: 'MGR eltávolítása',
        removeMgrFrom: 'Az MGR szerepkör eltávolítása innen: {node}',
        addMds: 'MDS hozzáadása',
        removeMds: 'MDS eltávolítása',
        removeMdsFrom: 'Az MDS szerepkör eltávolítása innen: {node}',
        mdsSection: 'Metadata server (MDS)',
        noMds: 'Nincs deklarált MDS — egy fájlrendszerhez előbb kell egy',
        mdsHint: 'Az MDS-tagság az első naptól önálló: CephFS nélküli klaszter nem deklarál, egy aktív plusz egy standby jól kiszolgál egy fájlrendszert. A Ceph a deklarált démonok közül maga választ aktívat és standbyt.',
        mdsActiveFor: 'aktív — {fs}',
        mdsNotObserved: 'még nem megfigyelt',
        lastMdsGuard: 'Az utolsó MDS nem távolítható el, amíg létezik fájlrendszer — előbb távolítsd el a fájlrendszereket',
        lastMonGuard: 'Az utolsó MON nem távolítható el — a klaszter megsemmisítése az egyetlen kiút',
        lastMgrGuard: 'Az utolsó MGR nem távolítható el — egy kezelt klaszter sosem fut manager nélkül',
        registerDevice: 'OSD hozzáadása',
        unregisterDevice: 'Deregisztrálás',
        activeDeviceGuard: 'Aktív OSD — az OSD-életcikluson keresztül távozik, nem a nyilvántartásból',
        colNode: 'Csomópont',
        devicePhase: { registered: 'Regisztrálva', active: 'Aktív' },
        health: 'Egészség',
        state: 'Állapot',
        fsid: 'fsid',
        fsidPending: 'hiányzik — próbáld újra a bootstrapet',
        version: 'Ceph-verzió',
        publicNetwork: 'Public hálózat',
        clusterNetwork: 'Cluster hálózat',
        clusterNetworkCollapsed: '= public',
        noActions: 'Ebben a fázisban nincs elérhető művelet',
        destroyedNote: 'Megsemmisített klaszter — a sor hamarosan automatikusan eltűnik'
      },
      overview: {
        services: 'Szolgáltatások',
        ok: 'egészséges',
        warning: 'warning',
        down: 'leállt',
        pgTitle: 'PG-állapotok',
        pgTotal: '{n} PG összesen',
        capacityTitle: 'Tárhely',
        ioTitle: 'Jelenlegi I/O',
        ioReadBw: 'Olvasási sávszélesség',
        ioWriteBw: 'Írási sávszélesség',
        ioReadIops: 'Olvasási IOPS',
        ioWriteIops: 'Írási IOPS',
        notObserved: 'még nem megfigyelt'
      },
      osd: {
        colId: 'ID',
        colClass: 'Device class',
        colState: 'Állapot',
        colSize: 'Méret',
        colPgs: 'PG',
        empty: 'Nincs OSD — adj hozzá egyet egy deklarált adatlemezből',
        markIn: 'Jelölés IN-re',
        markOut: 'Jelölés OUT-ra',
        scrub: 'Scrub futtatása',
        deepScrub: 'Mély scrub futtatása',
        restart: 'Szolgáltatás újraindítása',
        details: 'Részletek',
        actionGuard: 'Csak üzembe helyezett klaszter aktív OSD-jén',
        inTitle: 'OSD jelölése IN-re',
        inBody: 'osd.{id} visszatér az adatelosztásba (ceph osd in): a Ceph adatokat egyensúlyoz rá.',
        outTitle: 'OSD jelölése OUT-ra',
        outBody: 'osd.{id} kilép az adatelosztásból (ceph osd out): az adatai máshová egyensúlyozódnak, és a redundancia CSÖKKENT, amíg a backfill fut. Bármikor visszafordítható a Jelölés IN-re művelettel.',
        scrubTitle: 'Scrub ütemezése',
        scrubBody: 'Scrub lesz ütemezve az osd.{id}-re: a mon sorba állítja, és a következő sweepek PG-állapotai mesélik el az eredményt.',
        deepScrubTitle: 'Mély scrub ütemezése',
        deepScrubBody: 'Mély scrub lesz ütemezve az osd.{id}-re: a bájtokat is ellenőrző változat — nehezebb az I/O-n, ugyanaz a mechanika.',
        restartTitle: 'OSD-szolgáltatás újraindítása',
        restartBody: 'osd.{id} leáll és újraindul a worker felügyeletén keresztül a saját csomópontján.',
        started: 'Művelet elindítva — a megfigyelés magától frissül',
        error: 'Az OSD-műveletet a rendszer elutasította'
      },
      osdDetail: {
        title: 'OSD részletei',
        tabGeneral: 'Általános',
        tabNetwork: 'Hálózat',
        tabDevices: 'Eszközök',
        version: 'Verzió',
        hostname: 'Hostnév',
        dataPath: 'OSD-adatútvonal',
        objectStore: 'OSD object store',
        encrypted: 'Titkosítva',
        yes: 'Igen',
        no: 'Nem',
        memory: 'Memóriahasználat (PSS)',
        pid: 'Process ID (PID)',
        front: 'Front cím (kliens & monitor)',
        hbFront: 'Front heartbeat-cím',
        back: 'Back cím (OSD)',
        hbBack: 'Back heartbeat-cím',
        colDevice: 'Device',
        colType: 'Típus',
        colPhysical: 'Fizikai device',
        colSize: 'Méret',
        volumeTitle: 'Kötet részletei',
        creationTime: 'Létrehozás dátuma',
        lvName: 'LV Name',
        lvPath: 'LV Path',
        lvUuid: 'LV UUID',
        vgName: 'VG Name',
        noDevices: 'Ehhez az OSD-hez nincs megfigyelt device'
      },
      restart: {
        title: 'Szolgáltatás újraindítása',
        monBody: 'A MON démon a(z) {node} csomóponton leáll és újraindul a worker felügyeletén keresztül.',
        mgrBody: 'Az MGR démon a(z) {node} csomóponton leáll és újraindul a worker felügyeletén keresztül.',
        started: 'Újraindítás elindítva — a megfigyelés magától frissül',
        error: 'Az újraindítás el lett utasítva'
      },
      encryptionMode: {
        alwaysOn: 'Mindig engedélyezve (dmcrypt)',
        alwaysOff: 'Mindig letiltva',
        perOsd: 'OSD-nként választható',
        section: 'OSD-titkosítás at rest',
        title: 'Az OSD-titkosítási mód módosítása',
        hint: 'Így készülnek elő az ÚJ OSD-k. A meglévő OSD-k megtartják a lemezenkénti állapotukat: a megváltoztatásához az OSD-t el kell távolítani és újra létre kell hozni.',
        body: 'A mód „{mode}” lesz, és CSAK az ÚJ OSD-kre érvényes: minden meglévő OSD megtartja a jelenlegi titkosítási állapotát.',
        apply: 'Mód módosítása',
        error: 'A módváltás el lett utasítva'
      },
      pin: {
        address: 'Public cím (opcionális rögzítés)',
        clusterAddress: 'Cluster cím (opcionális rögzítés)',
        autoPlaceholder: 'automatikus a(z) {cidr} alhálózaton',
        hint: 'Démononkénti címzés: üresen = a Ceph magától kapcsolódik a deklarált hálózaton belül; kitöltve = ez a példány a saját konf-szekciójában a címhez lesz rögzítve.'
      },
      addMon: {
        title: 'Csomópont hozzáadása',
        node: 'Csomópont',
        address: 'Public cím',
        addressHint: 'A csomópont címei, amelyeket az IPAM ismer a public alhálózaton belül — automatikus, ha egy meglévő deklaráció lefedi a csomópontot.',
        clusterAddress: 'Cluster cím',
        clusterAddressHint: 'Kötelező: a cluster alhálózat külön van, és a csomópont ott még nincs deklarálva.',
        noAddresses: 'Az IPAM nem ismer címet ehhez a csomóponthoz az alhálózaton belül',
        error: 'A mon hozzáadása el lett utasítva'
      },
      removeMon: {
        title: 'MON eltávolítása',
        body: 'A MON és a kolokált MGR-je elhagyja a(z) {node} csomópontot. Üzembe helyezett klaszteren a démonok leállnak és kikerülnek a kvórumból.',
        error: 'A MON eltávolítása el lett utasítva'
      },
      addMgr: {
        title: 'MGR hozzáadása',
        node: 'Csomópont',
        hint: 'Haladó (szétválasztott MON/MGR): egy standalone manager születik a kiválasztott tagcsomóponton, egy csomóponthoz kötött feladattal. A Ceph active/standby választása magától jelöli ki az aktív MGR-t.',
        error: 'Az MGR hozzáadása el lett utasítva'
      },
      removeMgr: {
        title: 'MGR eltávolítása',
        body: 'A standalone MGR elhagyja a(z) {node} csomópontot. Üzembe helyezett klaszteren a démon leáll, az állapota törlődik; a csomópont MON-jához (ha van) nem nyúlunk.',
        error: 'Az MGR eltávolítása el lett utasítva'
      },
      addMds: {
        title: 'MDS hozzáadása',
        node: 'Csomópont',
        hint: 'A CephFS metadata servere: a kiválasztott tagcsomóponton születik egy csomóponthoz kötött feladattal, a worker felügyeli, mint a MON-t és az MGR-t. A Ceph magától választ aktívat és standbyt — egy aktív plusz egy standby jól kiszolgál egy fájlrendszert.',
        error: 'Az MDS hozzáadása el lett utasítva'
      },
      removeMds: {
        title: 'MDS eltávolítása',
        body: 'Az MDS elhagyja a(z) {node} csomópontot. Üzembe helyezett klaszteren a démon leáll, az állapota törlődik; az API az utolsó MDS-t elutasítja, amíg egy fájlrendszernek szüksége van rá.',
        error: 'Az MDS eltávolítása el lett utasítva'
      },
      split: {
        title: 'Szétválasztott MON/MGR',
        label: 'MON és MGR engedélyezése különböző csomópontokon',
        hint: 'Kikapcsolva (default) = a ratifikált standard: minden MON mellett egy kolokált MGR fut, egyetlen tagság. Bekapcsolva = az MGR-ek tagsága önállóvá válik, az MGR hozzáadása/eltávolítása műveletekkel kezelve a Kezelő csomópontok lapon.',
        enable: 'Bekapcsolás',
        disable: 'Kikapcsolás',
        enableBody: 'Az MGR-ek tagsága függetlenné válik a MON-októl, a jelenlegi kolokációból inicializálva. Az MGR hozzáadása/eltávolítása műveletek a Kezelő csomópontok lapon élesednek. Ez lazít a platform defaultján — csak akkor tartsd meg, ha tudod, miért kell.',
        disableBody: 'Visszatérés a standard kolokációhoz: egy MGR minden MON mellett, egyetlen tagság. Csak akkor legális, ha az MGR-ek tagsága már egybeesik a MON-okéval — előbb igazítsd hozzá az MGR hozzáadása/eltávolítása műveletekkel, különben az API elutasítja.',
        error: 'A módosítás el lett utasítva'
      },
      rawEditor: {
        title: 'Nyers CRUSH-szerkesztő',
        label: 'A crushmap nyers szerkesztőjének megjelenítése a CRUSH lapon',
        hint: 'Kikapcsolva (default) = a szabályok vezetett felülete a standard eszköz. Bekapcsolva = a CRUSH lap a dekompilált crushmapet is megjeleníti szerkeszthető szövegként. A mentéshez mindig sudo kell, megerősítésként a klaszter neve, és a crushtool compile + tesztjén megy át, MIELŐTT elérné a klasztert.'
      },
      osdFlags: {
        section: 'Globális OSD-flagek',
        title: 'OSD-flag felülbírálás',
        notObserved: 'még nem megfigyeltek',
        standardFlowsHint: 'A platform standard folyamatai a normál esetekben maguktól kezelik ezeket a flageket (egy csomópont karbantartása célzott nooutot állít be, a lemezcsere az OSD-életcikluson megy át). Ez a szekció a kézi felülbírálás annak az operátornak, aki tudja, mit csinál.',
        notDeployedGuard: 'OSD-flagek csak üzembe helyezett klaszteren léteznek',
        set: 'Flag beállítása',
        unset: 'Flag eltávolítása',
        setBody: 'A globális {flag} flag BEÁLLÍTÁSRA kerül az osdmapen. Addig marad, amíg explicit el nem távolítják — egy elfelejtett flag rontja a klaszter öngyógyítását.',
        unsetBody: 'A globális {flag} flag ELTÁVOLÍTÁSRA kerül az osdmapről.',
        error: 'A flag módosítása el lett utasítva',
        flag: {
          noout: 'Egyetlen OSD sem lesz outnak jelölve az adatelosztásból — nincs újraegyensúlyozás egy démon elvesztésekor',
          norebalance: 'Az adatok újraegyensúlyozása felfüggesztve',
          nobackfill: 'A backfill felfüggesztve',
          norecover: 'A recovery felfüggesztve',
          pause: 'A kliensek TELJES I/O-ja szünetel (olvasások és írások)',
          noin: 'Az elinduló OSD-k nem lesznek automatikusan innek jelölve',
          nodown: 'Az elérhetetlen OSD-k nem lesznek downnak jelölve — valódi hibákat takar el'
        }
      },
      pools: {
        section: 'Készletek',
        create: 'Készlet létrehozása',
        createGuard: 'Készletek csak üzembe helyezett klaszteren léteznek',
        notObserved: 'Nincs megfigyelés a készletekről — a mon sweepje ide jelent',
        empty: 'Nincs készlet a klaszteren',
        colName: 'Név',
        colReplication: 'Size / min size',
        colPgNum: 'PG',
        colApplication: 'Alkalmazás',
        colRule: 'CRUSH-szabály',
        colUsage: 'Kihasználtság',
        observedAtLabel: 'Megfigyelve',
        objects: '{n} objektum',
        inUseBy: 'használja: {name}',
        internalGuard: 'A Ceph belső készlete — a platform sosem törli',
        delete: 'Készlet törlése',
        deleteGuard: 'A(z) {name} tároló fogyasztja — előbb töröld a tárolót',
        hint: 'Csak replikált készletek (az erasure coding a v1 scope-ján kívül van). A replikáció a Cephben él: ez a tábla a mon sweepje által megfigyelt igazság.',
        createTitle: 'Készlet létrehozása',
        createHint: 'A készlet a kért replikációval és engedélyezett rbd alkalmazással születik a klaszteren — a munkát egy feladat végzi egy MON-csomóponton. Kapcsold be a „Felajánlás tárolóként” opciót, hogy ugyanazzal a gesztussal rögtön fogyaszd is.',
        name: 'A készlet neve',
        nameHint: 'DNS-biztos (kisbetűk, számjegyek, kötőjelek).',
        size: 'Replikák (size)',
        sizeHint: 'Minden objektum másolatai. Default 3.',
        minSize: 'Minimális replikák (min_size)',
        minSizeHint: 'Az I/O kiszolgálásához minimálisan szükséges másolatok — size − 1-et követi, amíg nem módosítod.',
        createError: 'A készlet létrehozása el lett utasítva',
        deleteTitle: 'Készlet törlése',
        deleteBody: 'A(z) {pool} készlet és MINDEN benne lévő objektum visszafordíthatatlanul megsemmisül. A megerősítéshez írd be a készlet nevét.',
        confirmLabel: 'A készlet neve',
        confirmHint: 'A megerősítéshez írd be a készlet nevét',
        deleteError: 'A készlet törlése el lett utasítva',
        detailTitle: 'Készlet részletei',
        autoscaler: 'PG Autoscaler',
        autoscalerOn: 'Aktív',
        autoscalerOff: 'Inaktív',
        autoscalerWarn: 'Értesítés',
        pgNumLabel: 'PG-k száma',
        pgNumCaption: 'Megfigyelt: az autoscaler magától is módosíthatja — ez a mező egy kívánságot ír.',
        storage: 'Kapcsolt TVirt-tároló',
        addAsStorage: 'Hozzáadás TVirt-tárolóként',
        ruleSudoHint: 'A CRUSH-szabály cseréjéhez az operátori jelszó szükséges.',
        updateError: 'A készlet módosítása el lett utasítva',
        updated: 'A készlet módosítása elindítva — a megfigyelés magától frissül'
      },
      crush: {
        section: 'CRUSH-szabályok',
        notObserved: 'Még nincs CRUSH-megfigyelés — a mon sweepje ide jelent',
        empty: 'Nincs megfigyelt szabály a klaszteren',
        hint: 'Egy szabály dönti el, HOVÁ kerülnek az egyes objektumok másolatai — a hibatartománya az az egység, amely adatvesztés nélkül hibásodhat meg. A készletek egy szabályra mutatnak; a builtin replicated_rule (szerverenként egy replika) a születési default.',
        create: 'Szabály létrehozása',
        createGuard: 'CRUSH-szabályok csak üzembe helyezett klaszteren léteznek',
        createTitle: 'CRUSH-szabály létrehozása',
        createHint: 'Egy szabály = egy hibatartomány-választás. A szabály replikáltan születik a default rooton — a munkát egy feladat végzi egy MON-csomóponton; a készleteket utólag társítsd a Készletek lapról.',
        createError: 'A szabály létrehozása el lett utasítva',
        name: 'A szabály neve',
        nameHint: 'DNS-biztos (kisbetűk, számjegyek, kötőjelek).',
        domain: 'Hibatartomány',
        domainChoice: {
          osd: 'Minden replika másik OSD-n',
          host: 'Minden replika másik szerveren',
          rack: 'Minden replika másik rackben'
        },
        domainCustom: 'Egyéni (kézzel írt stepek)',
        domainOther: 'Minden replika másik {type} egységben',
        rackGuardHint: 'A megfigyelt hierarchiában nem létezik rack bucket: a szabály így is létrehozható, de egyetlen készlet sem mutathat rá, amíg egy rack nincs deklarálva a tagszerverek pozíciójában (a csomópont beállításai) — az újraigazító feladat felépíti a bucketet, és a társítás magától megnyílik.',
        treeTitle: 'Megfigyelt hierarchia',
        treeNotObserved: 'Nincs megfigyelés a hierarchiáról — a mon sweepje ide jelent',
        treeOsds: '{n} OSD',
        treeHint: 'A CRUSH-térkép, ahogy a klaszter látja: root → deklarált szintek → szerver (host) → OSD. A topológia az egyes szerverek deklarált pozícióját követi (a csomópont beállításai) — egy pozícióváltás feladattal igazítja újra.',
        unplacedWarning: 'Deklarált pozíció nélküli tagok: {nodes} — a hostjaik közvetlenül a root alatt maradnak, a deklarált topológián kívül. Deklaráld a pozíciót a csomópont beállításaiban (figyelmeztetés, sosem blokkolás).',
        colName: 'Név',
        colDomain: 'Hibatartomány',
        colPools: 'Készletek',
        builtinChip: 'builtin',
        builtinGuard: 'A klaszter default szabálya — a platform sosem törli',
        detailAction: 'Szabály részletei',
        detailType: 'Típus',
        backToRules: 'Szabályok',
        ruleNotObserved: 'A szabályok megfigyelt listája nem nevezi meg ezt a szabályt',
        noPools: 'Egyetlen készlet sem használja ezt a szabályt',
        delete: 'Szabály törlése',
        deleteTitle: 'CRUSH-szabály törlése',
        deleteBody: 'A(z) {rule} szabály lekerül a klaszter crushmapjéről. Egyetlen készlet sem használhatja. A megerősítéshez írd be a szabály nevét.',
        deleteGuard: 'A(z) {name} készlet használja — előbb irányítsd át a készletet',
        confirmLabel: 'A szabály neve',
        confirmHint: 'A megerősítéshez írd be a szabály nevét',
        deleteError: 'A szabály törlése el lett utasítva',
        changeRule: 'CRUSH-szabály cseréje',
        changeRuleTitle: 'CRUSH-szabály cseréje',
        changeRuleHint: 'A készlet a kiválasztott szabály szerint kezdi elhelyezni az objektumait — a Ceph a meglévő adatokat is átmozgatja, hogy megfeleljen (teli készleten újraegyensúlyozás következik).',
        changeRuleError: 'A szabálycsere el lett utasítva',
        rule: 'CRUSH-szabály',
        rawTitle: 'Nyers crushmap (dekompilált)',
        rawWarning: 'VESZÉLY: ez a szöveg a klaszter TELJES elhelyezési politikája. Egy hibás térkép az összes készlet placementjét egyszerre törheti el. A mentés a crushtoollal fordítja és teszteli a térképet, MIELŐTT injektálná — de egy érvényes térkép is lehet rossz ötlet.',
        rawReload: 'Újratöltés',
        rawLoading: 'Lekérdezés folyamatban — egy read-only feladat dekompilálja a crushmapet…',
        rawSave: 'Crushmap mentése',
        rawSaveTitle: 'Crushmap injektálása',
        rawSaveBody: 'A módosított szöveg a TELJES klaszter crushmapjét váltja le a crushtool compile + tesztje után. A megerősítéshez írd be a klaszter nevét.',
        rawConfirmLabel: 'A klaszter neve',
        rawConfirmHint: 'A megerősítéshez írd be: {name}',
        rawError: 'A crushmap-művelet nem sikerült',
        rawHint: 'A szöveg a crushtool -d formátuma. A fordítási és teszthibák szóról szóra a crushtooltól jönnek vissza — a térkép nem éri el a klasztert, ha a két kapu egyike elbukik.'
      },
      objects: {
        poolsSection: 'Objektumböngésző',
        poolsHint: 'Válassz egy készletet az RBD-image-ei listázásához. Minden mély olvasás read-only feladatként fut egy MON-csomóponton — nem blokkolja (és nem is blokkolják) a valódi műveleteket.',
        deployedGuard: 'Az objektumlekérdezések csak üzembe helyezett klaszteren válaszolnak',
        browse: 'Objektumok tallózása',
        detailAction: 'Image részletei',
        backToPools: 'Készletek',
        backToImages: 'Image-ek',
        refresh: 'Frissítés',
        loading: 'Lekérdezés folyamatban — egy read-only feladat kérdezi a klasztert…',
        error: 'A lekérdezés nem sikerült',
        retry: 'Újrapróbálás',
        notRbd: '„{app}” alkalmazású készlet — nem tartalmaz RBD-image-eket, itt nincs mit tallózni',
        noImages: 'Nincs RBD-image ebben a készletben',
        colImage: 'Image',
        colSize: 'Méret',
        colObjects: 'Objektumok',
        colSnapshots: 'Pillanatképek',
        imagesHint: 'A fogyasztó rbd-tárolón lévő lemezek a lemez-id-jük nevét viselő image-ek. Az objektumszám a provisioned (méret / objektumméret) — a valós használat az image részleteiben él.',
        infoTitle: 'Image',
        infoSize: 'Virtuális méret',
        infoObjects: 'Objektumok (provisioned)',
        infoObjectSize: 'Objektumméret',
        infoPrefix: 'Objektum-prefix',
        infoFormat: 'Formátum',
        infoFeatures: 'Feature-ök',
        usageTitle: 'Valós használat (rbd du)',
        usageOf: '/ {provisioned} GiB provisioned',
        usageHint: 'Természeténél fogva thin: csak a megírt objektumok foglalnak bájtokat.',
        watchersTitle: 'Watcherek',
        noWatchers: 'Nincs watcher — most senki sem tartja nyitva ezt az image-et',
        snapshotsTitle: 'RBD-pillanatképek',
        noSnapshots: 'Nincs RBD-pillanatkép ezen az image-en',
        colSnapshot: 'Pillanatkép',
        colProtected: 'Védett',
        colTimestamp: 'Létrehozva',
        protected: 'védett',
        mappingTitle: 'Fizikai leképezés (OSD-halmaz)',
        mappingSampled: '{sampled} objektumos minta a(z) {total}-ból — őszinte összegzés: nagy image-eknél a halmaz a készlet ÖSSZES OSD-jéhez konvergál (a CRUSH az egész készleten szórja szét az objektumokat).',
        mappingComplete: 'Minden objektum leképezve ({total} / {total}).',
        objectQueryTitle: 'Egyetlen objektum leképezése',
        objectName: 'Objektumnév',
        objectHint: 'A RADOS-objektumnevek alakja <prefix>.<16-hex index> — a ceph osd map PG-vel és OSD-hármasokkal válaszol.',
        mapObject: 'Leképezés',
        primary: 'elsődleges: osd.{osd}'
      },
      registerDevice: {
        title: 'OSD-eszköz regisztrálása',
        hint: 'Élő klaszteren a regisztráció elő is KÉSZÍTI az eszközt: BlueStore OSD lesz belőle egy automatikus, csomóponthoz kötött feladattal (sosem üresen, ratifikálva 2026-07-24). Egy eszköz az egész flottában legfeljebb egy Ceph-klaszterhez tartozik.',
        disk: 'Adatlemez',
        diskHint: 'A csomópont deklarált adatlemezei — név és sorozatszám',
        noDeclared: 'Nincs deklarált adatlemez ezen a csomóponton — előbb jelöld meg őket a csomópont helyi beállításaiban',
        serialHint: 'Az eszköz sorozatszáma — az identitás-pin',
        encrypted: 'Az OSD titkosítása (dmcrypt)',
        encryptedHint: 'Az OSD-nkénti választás (a klaszter módja „OSD-nként választható”): a regisztráláskor fagy rá erre a lemezre — egy későbbi módváltás sosem írja át; azt a soronkénti titkosít/visszafejt művelet teszi.',
        error: 'A regisztráció el lett utasítva'
      },
      unregisterDevice: {
        title: 'Eszköz deregisztrálása',
        body: 'Csak nyilvántartás: {name} megszűnik ennek a klaszternek az OSD-jelöltje lenni. A bájtjaihoz nem nyúlunk.',
        error: 'A deregisztrálás el lett utasítva'
      },
      deploy: {
        action: 'Üzembe helyezés újrapróbálása',
        title: 'A bootstrap újrapróbálása',
        body: 'A születési bootstrap a jelenlegi konfigurációból indul újra: a monok elindulnak, minden regisztrált eszköz BlueStore OSD-ként lesz előkészítve és aktiválva. A művelet makrofeladatként fut — a fázis magától frissül.',
        started: 'Bootstrap elindítva — makrofeladatként folytatódik; a fázis magától frissül',
        error: 'A bootstrap el lett utasítva'
      },
      propose: {
        action: 'Felajánlás tárolóként',
        title: 'Felajánlás tárolóként',
        hintPool: 'A meglévő {name} készlet TVirt-tárolóvá válik: egy, a készletre korlátozott cephx-identitás kerül a keystore-ba, és a ceph-rbd tároló készen születik. A felajánlás a készletet fogyasztja — sosem hoz létre újat.',
        hintFs: 'A meglévő {name} fájlrendszer TVirt-tárolóvá válik: egy, a fájlrendszerre korlátozott cephx-identitás kerül a keystore-ba, és a cephfs tároló készen, csatolva születik. A felajánlás a fájlrendszert fogyasztja — sosem hoz létre újat.',
        name: 'A tároló neve',
        nameHint: 'DNS-1123, a scope-on belül egyedi — a cephx-identitás róla kapja a nevét.',
        path: 'Útvonal a fájlrendszeren belül',
        pathHint: 'Abszolút útvonal a fájlrendszeren belül, amelyet a tároló csatol — kétség esetén /.',
        alsoPropose: 'Felajánlás azonnal tárolóként',
        alsoProposePoolHint: 'A létrehozás után ugyanaz a gesztus felajánlja az újszülött készletet ceph-rbd tárolóként — két explicit hívás, egyetlen dialógus.',
        alsoProposeFsHint: 'A létrehozás után ugyanaz a gesztus felajánlja az újszülött fájlrendszert cephfs tárolóként — két explicit hívás, egyetlen dialógus.',
        guard: 'Felajánlás tárolóként — csak healthy klaszteren',
        started: 'Felajánlás elfogadva — a tároló materializálódik; a Tárolók alatt találod',
        submit: 'Tároló létrehozása',
        error: 'A felajánlás el lett utasítva'
      },
      fs: {
        section: 'Fájlrendszerek',
        create: 'Fájlrendszer létrehozása',
        createGuard: 'Fájlrendszerek csak üzembe helyezett klaszteren léteznek',
        mdsFirstGuard: 'Adj hozzá előbb egy MDS-t — a metadata server nélküli fájlrendszer használhatatlanul születik',
        notObserved: 'Nincs megfigyelés a fájlrendszerekről — a MON sweepje ide jelent',
        empty: 'Nincs fájlrendszer a klaszteren',
        colName: 'Név',
        colPools: 'Készletek',
        colMds: 'MDS',
        noActiveMds: 'nincs aktív MDS',
        delete: 'Fájlrendszer eltávolítása',
        deleteGuard: 'A(z) {name} tároló fogyasztja — előbb töröld a tárolót',
        hint: 'Egy fájlrendszer birtokolja a saját adat- és metadata-készleteit (cephfs.<név>.data / .meta): vele születnek és vele halnak — removeFs, sosem kézi készlettörlés. Ez a tábla a MON sweepje által megfigyelt igazság.',
        createTitle: 'Fájlrendszer létrehozása',
        createHint: 'A fájlrendszer a két készletével (application cephfs) születik a klaszteren, és a deklarált MDS-ek szolgálják ki — a munkát egy feladat végzi egy MON-csomóponton. Kapcsold be a „Felajánlás tárolóként” opciót, hogy ugyanazzal a gesztussal rögtön fogyaszd is.',
        name: 'A fájlrendszer neve',
        nameHint: 'DNS-biztos (kisbetűk, számjegyek, kötőjelek).',
        sizeHint: 'MINDKÉT születő készlet replikái. Default 3.',
        createError: 'A fájlrendszer létrehozása el lett utasítva',
        deleteTitle: 'Fájlrendszer eltávolítása',
        deleteBody: 'A(z) {fs} fájlrendszer és MINDEN benne lévő fájl visszafordíthatatlanul megsemmisül — az adat- és metadata-készletei vele halnak. A megerősítéshez írd be a fájlrendszer nevét.',
        confirmLabel: 'A fájlrendszer neve',
        confirmHint: 'A megerősítéshez írd be a fájlrendszer nevét',
        deleteError: 'A fájlrendszer eltávolítása el lett utasítva'
      },
      destroy: {
        action: 'Megsemmisítés',
        retryAction: 'A megsemmisítés újrapróbálása',
        retryGuard: 'A megsemmisítés fut — az újrapróbálás egy sikertelen megsemmisítésre való (különben a lease elutasítja)',
        title: 'A klaszter megsemmisítése',
        body: 'Az üzembe helyezett fabric le lesz bontva: e klaszter minden démona leáll, a rendszerállapota és a keystore-beli kulcsai felszabadulnak. Sikeres megsemmisítés után a klaszter automatikusan eltűnik.',
        confirmLabel: 'A klaszter neve',
        confirmHint: 'A megerősítéshez írd be a klaszter nevét',
        wipe: 'A regisztrált eszközök törlése',
        wipeHint: 'Bepipálva: minden regisztrált eszköz aláírásai törlődnek — a rajtuk lévő adatok megsemmisülnek. Pipa nélkül: a bájtok érintetlenek maradnak, és az eszközök regisztráltak maradnak.',
        guard: 'Megsemmisítés — semmi sincs üzembe helyezve',
        started: 'Megsemmisítés elindítva — makrofeladatként folytatódik; a fázis magától frissül',
        error: 'A megsemmisítés el lett utasítva'
      },
      delete: {
        guard: 'Törlés — csak nem üzembe helyezett konfiguráció (előbb semmisítsd meg)',
        title: 'Törlöd: {name}?',
        body: 'A konfiguráció és az eszköznyilvántartása törlődik. Csak addig legális, amíg semmi sincs üzembe helyezve.',
        error: 'A törlés el lett utasítva'
      }
    }
  }
}
